import React, { useState, Fragment, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
	Collapse,
	Navbar,
	NavbarToggler,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	Badge,
} from "reactstrap";
import "./styles.scss";
import Login from "../Login/Login";
import Register from "../Register/Register";
import Auth from "../../config/auth";
import logo from "../../images/group3776.png";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { fetchViewCart } from "../../redux/actions/products";

const Header = (props) => {
	let history = useHistory();
	const [isOpen, setIsOpen] = useState(false);
	const toggle = () => setIsOpen(!isOpen);
	const [badge, setBadge] = useState("");

	function handleLogout() {
		Auth.destroyToken();
		history.go("/");
	}

	useEffect(() => {
		props.fetchViewCart();
	}, []);

	useEffect(() => {
		if (props.carts.carts.data) {
			setBadge(
				Auth.isAuthenticated()
					? props.carts.carts.data.cart.items.length > 0
						? props.carts.carts.data.cart.items.length
						: 0
					: null
			);
		}
	}, [props.carts.carts]);

	return (
		<Fragment>
			<Navbar light expand="md navbar" id="themeOne">
				<NavbarBrand>
					<Link to="/">
						<img src={logo}  alt="STORE" className=""/>
					</Link>
				</NavbarBrand>
				<NavbarToggler onClick={toggle} />
				<Collapse isOpen={isOpen} navbar>
					<Nav className="header-links" navbar>
						<NavItem>
							<NavLink className="navLink">
								<Link to="/" className="link">HOME</Link>
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink className="navLink">
								<Link to="/auction" className="link">AUCTION</Link>
							</NavLink>
						</NavItem>
					</Nav>
					<Nav className="ml-auto" navbar>
					{Auth.isAuthenticated() && (
						<NavItem>
						<NavLink>
							<Link to="/notifications">
								<div className="badge-cart">
									<i
										className="fa fa-bell fa-lg"
										aria-hidden="true"
									></i>
									<Badge color="danger" className="badge-count">
										{1}
									</Badge>
								</div>
							</Link>
						</NavLink>
					</NavItem>
					)}
					{Auth.isAuthenticated() && (
						<NavItem>
						<NavLink>
							<Link to="/product-saved">
								<div className="badge-cart">
									<i
										className="fa fa-heart fa-lg"
										aria-hidden="true"
									></i>
								</div>
							</Link>
						</NavLink>
					</NavItem>
					)}
						<NavItem>
							<NavLink>
								<Link to="/cart">
									<div className="badge-cart">
										<i
											className="fa fa-shopping-cart fa-lg"
											aria-hidden="true"
										></i>
										<Badge color="danger" className="badge-count">
											{badge}
										</Badge>
									</div>
								</Link>
							</NavLink>
						</NavItem>
						{!Auth.isAuthenticated() && (
							<Fragment>
								<NavItem>
									<NavLink>
										<Login buttonLabel="LOGIN" />
									</NavLink>
								</NavItem>
								<NavItem>
									<NavLink>
										<Register buttonLabel="REGISTER"/>
									</NavLink>
								</NavItem>
							</Fragment>
						)}
						{Auth.isAuthenticated() && (
							<NavItem>
								<NavLink>
									<Link to="/setting">{Auth.getUser().full_name}</Link>
								</NavLink>
							</NavItem>
						)}
						{Auth.isAuthenticated() && (
							<NavItem>
								<NavLink>
									<Link onClick={handleLogout} className="link">LOGOUT</Link>
								</NavLink>
							</NavItem>
						)}
					</Nav>
				</Collapse>
			</Navbar>
		</Fragment>
	);
};

Header.propTypes = {
	carts: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
	carts: state.carts,
});

const pageActions = { fetchViewCart };
export default connect(mapStateToProps, pageActions)(Header);
